import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiHandler } from '../../api/apihandler';
import { HOLIDAYS_LIST } from '../../api/constants';

// Async thunk for fetching holidays
export const fetchHolidays = createAsyncThunk(
  'holiday/fetchHolidays',
  async ({ page = 1, limit = 100 }, { rejectWithValue }) => {
    try {
      const response = await apiHandler(HOLIDAYS_LIST, "POST", {
        page,
        limit
      });
      
      if (response.data?.response?.status === 200) {
        return response.data.data;
      } else {
        return rejectWithValue(response.data?.response?.message || 'Failed to fetch holidays');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

const holidaySlice = createSlice({
  name: 'holiday',
  initialState: {
    holidays: [],
    loading: false,
    error: null,
    meta: {
      total: 0,
      per_page: 100,
      current_page: 1,
      last_page: 1,
      first_page: 1,
    }
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetHolidays: (state) => {
      state.holidays = [];
      state.meta = {
        total: 0,
        per_page: 100,
        current_page: 1,
        last_page: 1,
        first_page: 1
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHolidays.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHolidays.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchHolidays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, resetHolidays } = holidaySlice.actions;

// Selectors
export const selectHolidays = (state) => state.holiday.holidays;
export const selectHolidaysLoading = (state) => state.holiday.loading;
export const selectHolidaysError = (state) => state.holiday.error;
export const selectHolidaysMeta = (state) => state.holiday.meta;

export default holidaySlice.reducer;